import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TenantUser,
  TenantUserListParams,
  TenantUserRequest,
  TenantUserState,
} from "src/types/tenantUser.types";

const initialState: TenantUserState = {
  createTenantUser: {
    loading: false,
    data: null,
    error: null,
  },
  editTenantUser: {
    loading: false,
    data: null,
    error: null,
  },
  tenantUserList: {
    loading: false,
    data: null,
    error: null,
  },
  changePassword: {
    loading: false,
    data: null,
    error: null,
  },
};

const tenantUserSlice = createSlice({
  name: "tenantUsers",
  initialState,
  reducers: {
    createTenantUserRequest: (
      state,
      action: PayloadAction<TenantUserRequest>
    ) => {
      state.createTenantUser.loading = true;
      state.createTenantUser.data = null;
      state.createTenantUser.error = null;
    },
    createTenantUserSuccess: (state, action: PayloadAction<any>) => {
      state.createTenantUser.loading = false;
      state.createTenantUser.data = action.payload;
      state.createTenantUser.error = null;
    },
    createTenantUserError: (state, action: PayloadAction<string>) => {
      state.createTenantUser.loading = false;
      state.createTenantUser.data = null;
      state.createTenantUser.error = action.payload;
    },
    resetCreateTenantUser: (state) => {
      state.createTenantUser.loading = false;
      state.createTenantUser.data = null;
      state.createTenantUser.error = null;
    },

    // Edit Tenant User
    editTenantUserRequest: (state, action: PayloadAction<TenantUserRequest>) => {
      state.editTenantUser.loading = true;
      state.editTenantUser.data = null;
      state.editTenantUser.error = null;
    },
    editTenantUserSuccess: (state, action: PayloadAction<any>) => {
      state.editTenantUser.loading = false;
      state.editTenantUser.data = action.payload;
      state.editTenantUser.error = null;
    },
    editTenantUserError: (state, action: PayloadAction<string>) => {
      state.editTenantUser.loading = false;
      state.editTenantUser.data = null;
      state.editTenantUser.error = action.payload;
    },
    resetEditTenantUser: (state) => {
      state.editTenantUser.loading = false;
      state.editTenantUser.data = null;
      state.editTenantUser.error = null;
    },

    // get tenants list actions
    getTenantUserListRequest: (
      state,
      action: PayloadAction<TenantUserListParams>
    ) => {
      state.tenantUserList.loading = true;
      state.tenantUserList.data = null;
      state.tenantUserList.error = null;
    },
    getTenantUserListSuccess: (state, action: PayloadAction<any>) => {
      state.tenantUserList.loading = false;
      state.tenantUserList.data = action.payload;
      state.tenantUserList.error = null;
    },
    getTenantUserListError: (state, action: PayloadAction<string>) => {
      state.tenantUserList.loading = false;
      state.tenantUserList.data = null;
      state.tenantUserList.error = action.payload;
    },

    // get tenants list actions
    changeTenantUserPasswordRequest: (
      state,
      action: PayloadAction<{ oldPassword: string; newPassword: string }>
    ) => {
      state.changePassword.loading = true;
      state.changePassword.data = null;
      state.changePassword.error = null;
    },
    changeTenantUserPasswordSuccess: (state, action: PayloadAction<any>) => {
      state.changePassword.loading = false;
      state.changePassword.data = action.payload;
      state.changePassword.error = null;
    },
    changeTenantUserPasswordError: (state, action: PayloadAction<string>) => {
      state.changePassword.loading = false;
      state.changePassword.data = null;
      state.changePassword.error = action.payload;
    },
    resetChangeTenantUserPassword: (state) => {
      state.changePassword.loading = false;
      state.changePassword.data = null;
      state.changePassword.error = null;
    },
  },
});

export const {
  // create tenant user actions
  createTenantUserRequest,
  createTenantUserSuccess,
  createTenantUserError,
  resetCreateTenantUser,

  // edit tenant user actions
  editTenantUserRequest,
  editTenantUserSuccess,
  editTenantUserError,
  resetEditTenantUser,

  // get tenant user list actions
  getTenantUserListRequest,
  getTenantUserListSuccess,
  getTenantUserListError,

  // change password actions
  changeTenantUserPasswordRequest,
  changeTenantUserPasswordSuccess,
  changeTenantUserPasswordError,
  resetChangeTenantUserPassword,
} = tenantUserSlice.actions;

export default tenantUserSlice.reducer;
